<template>
  <div class="new-journal" style="position: relative;">
    <template v-if="pageLoaded">
      <Header :hasHeaderLine="hasHeaderLine" />
      <currencies />
      <!-- Главный баннер -->
      <template>
        <div id="feed" v-if="articles.special">
          <div class="slide-header row">
            <slick ref="slickMainSlider" :options="slickOptionsMainSlider">
              <a
                  v-for="article in articles.special"
                  :href="article.url"
                  class="main-slide-container"
                  :key="'article-special-' + article.id"
              >
                <div class="hero-container">
                  <div class="hero heroimg" :style="{ 'background-image': 'url(\'' + article.image + '\')' }">
                  </div>
                  <div class="hero-inside title">
                    <div class="hero-inside-text">
                      <small class="label_backgorund">{{ article.categoryData.name }}</small>
                      <template v-if="article.card_name">
                        <div
                            class="h1 label_backgorund_white"
                            v-for="nameChunk in article.card_name.split('<br>')"
                            v-html="nameChunk" :key="'slider-article-name-chunk_' + nameChunk"
                        ></div>
                      </template>
                      <div class="h1 label_backgorund_white" v-else>{{ article.name }}</div>
                    </div>
                  </div>
                </div>
              </a>
            </slick>
          </div>
        </div>
      </template>

      <!-- Главная -->
      <template v-if="!category && !isJournal">
        <div class="container pc" v-if="articles.desktop">
          <cards-section title="Лайфхаки" code="life-hacks" :items="articles.desktop.lifeHacks"
            link="/category/lifehacks" />
          <cards-section title="Знания" code="knowledge" :items="articles.desktop.knowledge"
            link="/category/knowledge" />
          <cards-section title="Тесты" code="tests" :items="articles.desktop.test" link="/category/test" />
          <InvestBanner />
          <cards-section v-if="articles.desktop" title="Ревью" code="reviews" :items="articles.desktop.reviews"
            link="/category/reviews" />
        </div>

        <!--Mobile-->
        <div class="container phone new-main-feed">
          <div class="topical-container">
            <mobile-section-slider-new-copy v-if="articles.mobile && articles.topical" code="topical-articles"
              name="Актуально сейчас" :items="articles.topical" :no-gray="false" link="/journal" />
          </div>

          <mobile-feed v-if="articles.mobile && articles.mobile.lifeHacks.slice(0, 4).length" code="lifehacks-mobile"
            name="Лайфхаки" :items="articles.mobile.lifeHacks.slice(0, 4)" link="/category/lifehacks" />

          <mobile-feed v-if="articles.mobile && articles.mobile.knowledge.slice(0, 4).length" code="knowledge-mobile"
            name="Знания" :items="articles.mobile.knowledge.slice(0, 4)" link="/category/knowledge" />
        </div>

        <div class="phone">
          <InvestBanner />
        </div>

        <div class="container phone new-main-feed">
          <mobile-feed v-if="articles.mobile && articles.mobile.test.slice(0, 4).length" code="tests-mobile"
            name="Тесты" :items="articles.mobile.test.slice(0, 4)" link="/category/test" />

          <mobile-feed v-if="articles.mobile && articles.mobile.reviews.slice(0, 4).length" code="reviews-mobile"
            name="Ревью" :items="articles.mobile.reviews.slice(0, 4)" link="/category/reviews" />
        </div>
      </template>

      <!-- Страница журнала -->
      <template v-if="category || isJournal">

        <!-- Desktop -->
        <div class="container pc journal" v-if="articles.desktop">
          <div class="journal-section-btns">
            <button :class="{ active: category === null }" v-on:click="setCategory(null)">Все</button>
            <button :class="{ active: category === 'lifehacks' }"
              v-on:click="setCategory('lifehacks')">Лайфхаки</button>
            <button :class="{ active: category === 'knowledge' }" v-on:click="setCategory('knowledge')">Знания</button>
            <button :class="{ active: category === 'test' }" v-on:click="setCategory('test')">Тесты</button>
            <button :class="{ active: category === 'reviews' }" v-on:click="setCategory('reviews')">Ревью</button>
          </div>

          <template v-if="category">
            <template v-for="n in currentPage * 3">
              <template v-if="articles.desktop[n]">
                <cards-section :key="'journal-rows_' + n" :code="category" :items="articles.desktop[n]"
                  v-if="articles.desktop[n]" />
              </template>
            </template>
            <div v-observe-visibility="handleScrolledToBottom"></div>
            <div class="loader-wrapper" v-if="showLoader">
              <img src="@/assets/img/circle-loader.svg" class="circle-loader">
            </div>
          </template>
          <template v-else>
            <template v-for="n in currentPage * 3">
              <template v-if="articles.desktop.all">
                <cards-section :key="'journal-rows_' + n" :items="articles.desktop.all[n]"
                  v-if="articles.desktop.all[n]" />
              </template>
            </template>
            <div v-observe-visibility="handleScrolledToBottom"></div>
            <div class="loader-wrapper" v-if="showLoader">
              <img src="@/assets/img/circle-loader.svg" class="circle-loader">
            </div>
          </template>
        </div>

        <!-- Mobile -->
        <div class="container-315 phone journal" v-if="articles.mobile">
          <div class="journal-section-btns">
            <div>
              <button :class="{ active: category === null }" v-on:click="setCategory(null)">Все</button>
              <button :class="{ active: category === 'lifehacks' }"
                v-on:click="setCategory('lifehacks')">Лайфхаки</button>
              <button :class="{ active: category === 'knowledge' }"
                v-on:click="setCategory('knowledge')">Знания</button>
              <button :class="{ active: category === 'test' }" v-on:click="setCategory('test')">Тесты</button>
              <button :class="{ active: category === 'reviews' }" v-on:click="setCategory('reviews')">Ревью</button>
            </div>
          </div>
          <div class="journal-feed-wrapper">
            <template v-if="category">
              <template v-for="n in currentPage * 4">
                <template v-if="articles.mobile[n]">
                  <div :key="'extra-mobile-card' + n" v-if="articles.mobile[n]">
                    <ArticleCardMobile v-if="articles.mobile[n]" :article="articles.mobile[n]" />
                  </div>
                </template>
              </template>
              <div v-observe-visibility="handleScrolledToBottom"></div>
              <div class="loader-wrapper" v-if="showLoader">
                <img src="@/assets/img/circle-loader.svg" class="circle-loader">
              </div>
            </template>
            <template v-else>
              <template v-for="n in currentPage * 4">
                <template v-if="articles.mobile.all">
                  <div :key="'extra-all-mobile-card' + n" v-if="articles.mobile.all[n]">
                    <ArticleCardMobile v-if="articles.mobile.all[n]" :article="articles.mobile.all[n]" />
                  </div>
                </template>
              </template>
              <div v-observe-visibility="handleScrolledToBottom"></div>
              <div class="loader-wrapper" v-if="showLoader">
                <img src="@/assets/img/circle-loader.svg" class="circle-loader">
              </div>
            </template>
          </div>
        </div>
      </template>
      <SocialBanner />
      <Footer />
    </template>
  </div>
</template>

<script>
import Slick from 'vue-slick';
import request from '@/api/axios';
import CardsSection from '@/components/newRedesign/CardsSectionNewCopy';
import MobileFeed from '@/components/newRedesign/MobileFeed';
import MobileSectionSliderNewCopy from '@/components/newRedesign/MobileSectionSliderNewCopy';
import Footer from '@/components/newRedesign/FooterNewCopy';
import Currencies from '@/components/redesign/Currencies.vue';
import Header from '@/components/newRedesign/HeaderNewCopy';
import InvestBanner from '@/components/newRedesign/UI/InvestBanner';
import ArticleCardMobile from '@/components/newRedesign/UI/ArticleCardMobile.vue';
import SocialBanner from '@/components/newRedesign/UI/SocialBanner.vue';
import $ from 'jquery'

export default {
  data: () => {
    return {
      data: {},
      pageLoaded: false,
      currentPage: 1,
      lastPage: 1,
      showLoader: false,
      articles: {},
      allArticlesRow: [],
      activeMonth: '',
      category: null,
      isJournal: false,
      hasHeaderLine: true,
      slickOptionsMainSlider: {
        arrows: true,
        autoplay: false,
        autoplaySpeed: 3000,
        dots: true,
        dotsClass: 'slide-header-dots',
        centerMode: true,
        touchThreshold: 10,
        centerPadding: '16px',
        variableWidth: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        responsive: [{
          breakpoint: 576,
          settings: {
            arrows: false,
            centerPadding: '16px',
            slidesToShow: 1,
            variableWidth: true
          }
        }]
      },
      slickOptionsCards: {
        arrows: false,
        dots: false,
        slidesToShow: 1,
        touchThreshold: 10,
        slidesToScroll: 1,
        variableWidth: true
      },
      slickOptionsMoney: {
        arrows: false,
        dots: false,
        infinite: true,
        slidesToShow: 4,
        touchThreshold: 10,
        slidesToScroll: 1,
        responsive: [{
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            swipeToSlide: true
          }
        }]
      },
      templates: {
        4: 'simple',
        5: 'emoji',
        6: 'double',
        7: 'image',
        8: 'list',
        9: 'quote',
        11: 'number'
      },
      templatesWeight: {
        double: 2,
        list: 0.3
      }
    }
  },
  head: {
    link: function () {
      return [
        {
          rel: 'canonical',
          href: ('https://finsite.me/' + (this.$route.params.code ? 'category/' + this.$route.params.code : ''))
        }
      ]
    }
  },
  components: {
    Slick,
    CardsSection,
    MobileSectionSliderNewCopy,
    Footer,
    Currencies,
    Header,
    InvestBanner,
    MobileFeed,
    ArticleCardMobile,
    SocialBanner
  },
  watch: {
    $route(to) {
      this.isJournal = to.path === '/journal';
    }
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  async created() {
    this.pageLoaded = false;
    this.data = await this.getArticles();
    this.data.articles = this.data.articles.map(item => {
      item.categoryData = this.data.categories.find(category => category.id === item.category);
      item.url = '/article' + item.url;
      item.template = this.templates[item.template];
      if (item.template === 'list') item.template = 'simple';
      item.original_name = item.name;
      item.name = item.card_name || item.name;
      item.image = this.$config.hostname + item.image;
      return item;
    });

    this.onLoad();
    this.isJournal = this.$route.path === '/journal';
  },
  mounted() {
  },
  methods: {
    tgScript() {
      this.$nextTick(() => {
        $(document).ready(function () {
          const $el = window.matchMedia('(min-width: 599px)').matches ? $('.pc .footer') : $('.phone .footer');
          $(window).scroll(function () {
            const hT = $el.offset().top,
              hH = $el.outerHeight(),
              wH = $(window).height(),
              wS = $(this).scrollTop();

            if (wS > (hT + hH - wH) - 300) {
              $('.tg-floatted-button').addClass('absolute');
            } else {
              $('.tg-floatted-button').removeClass('absolute');
            }
          });
        });
      });
    },
    async onLoad() {
      this.pageLoaded = false;

      // Выбрана категория
      if (this.category) {
        const special = this.data?.articles?.slice(0, 3);

        this.activeMonth = this.data?.activeMonth;

        const articles = this.data?.articles?.filter(item => item.categoryData.code === this.category);

        this.articles = {
          mobile: articles,
          desktop: this.getArticlesForRows(articles.map(item => {
            if (item.template === 'list') item.template = 'simple';
            return item;
          })),
          month: this.data?.month,
          special: special
        };

      } else {
        const special = this.data?.articles?.slice(0, 3);
        const simple = this.data?.articles?.slice(3);
        const feed = this.data?.articles?.slice(3, 11);
        const simpleMobile = this.data?.articles;
        const topical = this.data?.articles?.slice(4, 7);

        this.activeMonth = this.data?.activeMonth;
        this.articles = {
          desktop: {
            lifeHacks: simple.filter(item => item.categoryData.code === 'lifehacks'),
            knowledge: simple.filter(item => item.categoryData.code === 'knowledge'),
            test: simple.filter(item => item.categoryData.code === 'test'),
            reviews: simple.filter(item => item.categoryData.code === 'reviews'),
            all: this.getArticlesForRows(this.data?.articles)
          },
          mobile: {
            feed: feed,
            lifeHacks: simpleMobile.filter(item => item.categoryData.code === 'lifehacks'),
            knowledge: simpleMobile.filter(item => item.categoryData.code === 'knowledge'),
            test: simpleMobile.filter(item => item.categoryData.code === 'test'),
            reviews: simpleMobile.filter(item => item.categoryData.code === 'reviews'),
            gold: simpleMobile.filter(item => item.gold),
            all: simpleMobile
          },
          special: special,
          month: this.data?.month,
          topical: topical
        };

        this.lastPage = Math.ceil(this.data?.articles.length / 12)
      }
      window.scrollTo(0, 0);
      this.pageLoaded = true;
      this.tgScript();
    },
    getArticlesForRows(articles) {
      if (!articles) return [];
      let weight = 0;
      let curIndex = 0;
      return articles.reduce((acc, item) => {
        weight += (this.templatesWeight[item.template] || 1);
        if (weight > 4) {
          weight = (this.templatesWeight[item.template] || 1);
          curIndex++;
        }
        if (!acc[curIndex]) acc[curIndex] = [];
        acc[curIndex].push(item);
        return acc;
      }, []);
    },
    setCategory(code) {
      this.category = code;
      if (code === null) {
        this.category = null;
      } else {
        this.category = code;
      }
      this.onLoad();
      this.currentPage = 1
    },
    async getArticles() {
      return (await request({ action: 'get_articles' })).data;
    },
    monthChange(id) {
      this.activeMonth = id;
      this.$nextTick(function () {
        this.$refs['slickMoney_' + id][0].reSlick();
      });
    },
    handleScrolledToBottom(isVisible) {
      if (!isVisible) { return }
      if (this.currentPage >= this.lastPage) { return }
      this.showLoader = true
      this.currentPage++
      this.showLoader = false
    }
  }
}
</script>

<style scoped lang="scss">
.journal-section-btns {

  padding-top: 25px;
  margin-bottom: 26px;
}

.journal-section-btns button {
  margin: 0;
  margin-right: 10px;
  padding: 1px 5px;
  height: auto;
  font-family: 'Gilroy';
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  letter-spacing: 0.1em;
  color: #333333;
  border-radius: 4px;
  background-color: #F6F6F6;
}

.journal-section-btns button:hover {
  margin: 0;
  margin-right: 10px;
  padding: 1px 5px;
  height: auto;
  font-family: 'Gilroy';
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  letter-spacing: 0.1em;
  color: #F2F2F2;
  border-radius: 4px;
  background-color: #22B491;
}

.journal-section-btns .active {
  font-family: 'Gilroy';
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  letter-spacing: 0.1em;
  color: #F2F2F2;
  background-color: #22B491;
}

.journal-section-btns button:focus {
  outline: none;
  border: none;
}

.loader-wrapper {
  margin: 0 auto;
  margin-top: 50px;
  margin-bottom: 32px;
  width: 32px;
  height: 31px;
}

.circle-loader {
  animation: animate 1.5s infinite linear;
}

@keyframes animate {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.phone.container-315 {
  width: 315px;
  margin: auto;
}

.phone .journal-section-btns {
  width: 100vw;
  margin-left: calc((100vw - 315px) / -2);
  margin-bottom: 14px;
  padding: 15px;
  position: sticky;
  position: -webkit-sticky;
  top: 128px;
  background-color: #fff;
  border-top: 1px solid #F5F5F5;
  z-index: 1;

  div {
    width: 289px;
    margin: 0 auto;
    display: flex;
  }
}

.phone .journal-section-btns button {
  font-size: 10px;
  line-height: 12px;
  padding: 3px 5px;
}

.phone .journal-section-btns button:last-child {
  margin-right: 0;
}

.phone .journal-feed-wrapper {
  width: 100vw;
  margin-left: calc((100vw - 315px) / -2);
  background: #F5F5F5;
}

.topical-container {
  width: 100vw;
  margin-left: calc((100vw - 315px) / -2);
  padding-top: 30px;
}

.container.phone.new-main-feed {
  width: 315px;
}
</style>
